import { clsx } from "clsx";

import { getWhitelabelCustomization } from "common/helpers/utils";

import type { ReactNode } from "react";

interface NavItemProps {
  isExpanded: boolean;
  isActive?: boolean;
  isInteractive?: boolean;
  children: ReactNode;
  icon: ReactNode;
}

export default function NavItem({
  isExpanded,
  icon,
  isActive = false,
  isInteractive = true,
  children,
}: NavItemProps) {
  return (
    <div
      className={clsx(
        "group flex relative items-center justify-start gap-x-2.5 rounded-3xl transition-[background,shadow,border] text-nowrap border",
        "border lg:overflow-hidden lg:rounded-2xl lg:gap-x-2 h-12 lg:h-9 px-4 lg:p-2.5",

        isActive
          ? [
              "text-md-bold border-black-100 lg:border-purple-50 bg-white max-lg:shadow-md  lg:text-button-xs",
              getWhitelabelCustomization()
                ? "lg:shadow-[0_3px_6px_2px_rgba(17,24,39,0.20)]"
                : "lg:text-purple-500 lg:bg-purple-50",
            ]
          : [
              "text-md-medium lg:text-xs-medium border-transparent",
              isInteractive &&
                (getWhitelabelCustomization()
                  ? "lg:hover:bg-black-200"
                  : "lg:hover:border-black-200 lg:hover:bg-black-100"),
            ],
      )}
    >
      {/* Icon */}
      <span className={clsx("[&_svg]:size-5 lg:[&_svg]:size-4 shrink-0")}>
        {icon}
      </span>

      {/* Content */}
      <span
        className={clsx(
          "flex items-center transition-opacity duration-500 grow",
          isExpanded ? "opacity-100" : "opacity-0",
        )}
      >
        {children}
      </span>
    </div>
  );
}
